import api from '@/helpers/api'

const API_GIFT = '/api/voucher-gift/'
const API_PREVIEW = '/api/voucher-gift/preview'
const API_HISTORY = '/api/voucher-gift/history'

export default {
    namespaced: true,
    state: {
        status: '',
        distributions: [],
        memberPreview: { total_member: 0 },
        giftStatus: 'idle', 
        meta: {
            page: 1,
            limit: 10,
            total: 1,
            last_page: 1
        },
        filter: {},
        search: {},
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state) {
            state.status = 'error'
        },
        SET_DISTRIBUTIONS(state, distributions) {
            state.distributions = [...distributions]
        },
        SET_MEMBER_PREVIEW(state, preview) {
            state.memberPreview = { ...preview }
        },
        SET_GIFT_STATUS(state, status) {
            state.giftStatus = status
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = { ...filter }
        },
        clear_filter(state) {
            state.filter = {}
        },
        set_search(state, { search }) {
            state.search = { ...search }
        },
        clear_search(state) {
            state.search = {}
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
                last_page: 1
            }
        },
    },
    actions: {
        giftVoucher({ commit }, { data }) {
            commit('SET_GIFT_STATUS', 'loading')
            return new Promise((resolve, reject) => {
                api.request('post', API_GIFT, {}, data)
                    .then((result) => {
                        commit('SET_GIFT_STATUS', 'success')
                        commit('success')
                        return resolve(result.data)
                    }).catch((err) => {
                        commit('SET_GIFT_STATUS', 'error')
                        commit('error')
                        return reject(err)
                    })
            })
        },
        previewTarget({ commit }, params) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('get', API_PREVIEW, params)
                    .then((result) => {
                        commit('success')
                        commit('SET_MEMBER_PREVIEW', result.data.data)
                        return resolve(result.data.data)
                    }).catch((err) => {
                        commit('error')
                        return reject(err)
                    })
            })
        },

        getDistributionHistory({ commit, state }) {
            commit('request')
            const { meta, filter, search } = state
            return new Promise((resolve, reject) => {
                api.request('get', API_HISTORY, { meta, filter, search })
                    .then((result) => {
                        commit('success')
                        commit('SET_DISTRIBUTIONS', result.data.data.data_res)
                        commit('switch_page', { meta: { ...result.data.data.meta } })
                        return resolve()
                    }).catch((err) => {
                        commit('error')
                        return reject(err)
                    })
            })
        },
        getHistoryMembers({ commit }, { id, meta, search }) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('get', `${API_HISTORY}/${id}/members`, { meta, search })
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data)
                    }).catch((err) => {
                        commit('error')
                        return reject(err)
                    })
            })
        },
    },
    getters: {
        distributions: (state) => state.distributions,
        memberPreview: (state) => state.memberPreview,
        giftStatus: (state) => state.giftStatus,
    }
}
